import * as Types from '../../generated/types';

import gql from 'graphql-tag';
export type ICustomerContextCustomerFragment = { __typename?: 'Customer', id: string, name: string, status: Types.ICustomerStatus, usesPaymentReleaseStep: boolean, products: Array<Types.IProduct> };

export type ICustomerContextApplicationSummaryFragment = { __typename?: 'ApplicationSummary', id: string, status: Types.IApplicationStatus, legalName: string, dbaName?: string | null };

export const CustomerContextCustomerFragmentDoc = gql`
    fragment CustomerContextCustomer on Customer {
  id
  name
  status
  usesPaymentReleaseStep
  products
}
    `;
export const CustomerContextApplicationSummaryFragmentDoc = gql`
    fragment CustomerContextApplicationSummary on ApplicationSummary {
  id
  status
  legalName
  dbaName
}
    `;